export default __webpack_public_path__ + "static/media/company-altmenu.c42c46f2.svg";